import { useTheme } from '@/contexts/ThemeContext';

export const useRsColors = () => useTheme().rsColors;
